import Familiarize from './Familiarize.vue';

export default Familiarize;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/itemsblock/components/familiarize/index.ts